
export function Privacy() {
  return (
    <div id="privacy">
      <div className="container">
        <div className="section-title text-center">
          <h2>Privacy Policy for GPS Maps Navigation</h2>
        </div>
        <h3> Effective Date: August 4, 2025</h3>
        <p>
          This Privacy Policy explains how we collect, use, and share your
          information when you use our GPS Maps Navigation app. Your privacy is
          important to us, and we are committed to protecting your personal
          data.
        </p>
        <h3>Information We Collect</h3>
        <p>
          <ui>
            <li> Personal Information </li>
            <ol>
              We do not collect personal information such as your name, email,
              or contact details unless you voluntarily provide it through
              feedback or support channels.
            </ol>
            <li> Location Data The App</li>
            <ol>
              collects precise location data to provide navigation, route
              optimization, nearby places, and other GPS-based features. This
              data is used in real-time and is not stored on our servers.
            </ol>
            <li> Usage Data </li>
            <ol>
              {" "}
              We automatically collect app usage statistics such as screen
              views, session duration, and user interactions via Firebase
              Analytics and Google AdMob for app improvement and ad targeting.{" "}
            </ol>
            <li> Device Information</li>
            <ol>
              {" "}
              We collect device type, OS version, unique device identifiers, and
              crash logs through Crashlytics to monitor performance and fix
              bugs.
            </ol>
          </ui>
        </p>
        <h3>Third-Party Services </h3>
        We use the following third-party SDKs and services that may collect data
        under their own privacy policies:
        <li>
          Firebase Analytics (Google LLC) Used to understand user behavior and
          improve app features. 🔗 Firebase Privacy Policy{" "}
        </li>
        <li>
          Google AdMob Displays ads and may collect ad performance and
          engagement data. 🔗 Google Privacy Policy{" "}
        </li>
        <li>
          {" "}
          Firebase Crashlytics Collects crash reports to identify and resolve
          technical issues. 🔗 Crashlytics Policy{" "}
        </li>
        <li>
          Mapbox Provides map and location services. May collect location and
          usage data. 🔗 Mapbox Privacy Policy
        </li>
        <h3> How We Use Your Information</h3> We use collected data for the
        following purposes:{" "}
        <li>To provide and improve core GPS and navigation features</li>{" "}
        <li>To understand user behavior and app performance</li>{" "}
        <li> To serve relevant advertisements</li>{" "}
        <li>To detect and resolve crashes and bugs </li>
        <h3>Data Sharing and
        Disclosure</h3> We do not sell or rent your personal data. Data may be shared
        with third-party SDK providers solely for analytics, crash reporting, or
        ad personalization, in accordance with their privacy terms. 
        <h3>Data
        Retention </h3>
        We retain data only as long as necessary to fulfill the
        purposes outlined in this policy or as required by law. 
        <h3>Children’s
        Privacy </h3>Our App is not intended for use by children under the age of 13.
        We do not knowingly collect personal data from children. 
        <h3>Your Rights and
        Choices </h3>Depending on your jurisdiction, you may have rights to: <li>
        Access, correct, or delete your data </li><li>Opt out of personalized ads via
        device settings </li><li>Revoke permissions like location access </li>
        <h3>Security </h3>We
        take reasonable measures to protect your information from unauthorized
        access or disclosure. However, no method of transmission over the
        Internet is secure. 
      <h3>  Changes to This Policy </h3>We may update this Privacy
        Policy from time to time. Changes will be posted in the App or on this
        page with the revised date. 
        <h3>Contact Us </h3>If you have any questions or
        concerns about this Privacy Policy, please contact us at: 📧
        info@Jarvastech.com 📌 Jarvas Tech LTD
      </div>
    </div>
  );
};